// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","StarsCounter":"StarsCounter_StarsCounter__1hQku","StarsIcon":"StarsCounter_StarsIcon__1jZSC"};